import '../plugins/scrollevent'

export default function HOME () {
  $(()=>{

    $.scrollspy({
      trigger: 500,
      duration: 1000,
      onBefore() {
        $('.p-gnav').addClass('is-firstview')
      },
      onAfter() {
        $('.p-gnav').removeClass('is-firstview')
      }
    })

  })
}